@for (notification of notifications$ | async; track trackByID($index, notification)) {
  <app-notification
    (closed)="closeNotification($event)"
    [duration]="notification?.duration"
    [value]="notification?.value"
    [type]="notification?.type || 'warning'"
    [id]="notification?.id"
    @notificationReveal
  />
}
